import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  makeStyles,
  CardHeader,
  Divider,
  Typography,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

import { SIREN_CONFIG } from "config.js";
import md5 from 'md5';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { loadRoomList } from "utils/LoadConfiguration";

import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import koLocale from 'date-fns/locale/ko';
import moment from 'moment';
import {timeStringToDate} from '../../utils/helperFunc';


const theme = createTheme({
  overrides: {
    MuiInputBase: {
      input: {
        //   background: '#dd7711',
        //   padding: 10,
        fontSize: '16px',
      },
    },
  },
})


const CaregiverAddForm = (props) => {
  const { className, history, memberInfo,  ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [errorText, setErrorText] = useState('');
  const [roomList, setRoomList] = useState([]);
  const [checkedState, setCheckedState] = useState([]);

  const facility_id = useSelector((store) => store.user.facility_id);

  const [newStartTime, setNewStartTime] = React.useState(() => timeStringToDate('06:00'));
  const [newEndTime, setNewEndTime] = React.useState(() => timeStringToDate('22:00'));
  

  const handleSubmit = (event, values) => {
    event.preventDefault();

    if (values.caregiver_password !== values.caregiver_password_confirm) {
      setErrorText( formatMessage({id:'not_match_password'}) );
      return;
    }

    let sStartTime = "";
    let sEndTime = "";

    try {
      sStartTime = moment(newStartTime).format('HH:mm');
      sEndTime = moment(newEndTime).format('HH:mm');
    } catch (err) {
      alert('The alarm time is wrong.');
      return;
    }


    let newRoomList = [];
    roomList.map( (roomInfo, index) => {
      roomInfo.isMine = checkedState[index] === true ? 1 : 0;
      newRoomList.push(roomInfo);
    });


    fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/addCaregiver`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        caregiver_name: values.caregiver_name,
        caregiver_password: md5(values.caregiver_password),
        caregiver_tel_no: values.caregiver_tel_no,
        alarm_start_time: sStartTime,
        alarm_end_time: sEndTime
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {

          let newCaregiverId = responseData.caregiverId;
          if (newCaregiverId != null) {

            fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/updateCaregiverRoom`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                facility_id: facility_id,
                caregiverId: newCaregiverId,
                caregiverRoomList: newRoomList,
              }),
            })
            .then((response) => {
              return response.json();
            })
            .then((responseData) => {
              if (responseData.resultCode === "000") {
                alert(formatMessage({id:'caregiver_add_successful'}));
              } else {
                //에러
                console.log(responseData.resultMessage);
                alert(`${formatMessage({id:'caregiver_add_failed'})}\n${responseData.resultMessage}`);
              }
            });
          }

          setTimeout(() => {
            history.goBack();
          }, 500);
        } else {
          //에러
          console.log(responseData.message);
          alert(`${formatMessage({id:'caregiver_add_failed'})}\n${responseData.resultMessage}`);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(formatMessage({id:'caregiver_add_failed'}));
      });
  };


  const handleBack = () => {
    history.goBack();
  };


  const handleChange2 = (position) => {

    let updateCheckedState = checkedState.map( (item, index) =>
      index === position ? !item : item
    );

    setCheckedState(updateCheckedState);
  }


  useEffect( () => {

    async function loadRoomInfo() {
      // let rooms = await loadCaregiverRoomList(caregiverInfo.caregiverId)
      let rooms = await loadRoomList(facility_id);

      setRoomList(rooms);

      let newCheckedState = new Array(rooms.length).fill(false);

      rooms.map( (roomInfo, index) => {
        newCheckedState[index] = false;
      });

      setCheckedState(newCheckedState);
    }

    loadRoomInfo();
  }, []);


  return (

    <Formik
      initialValues={{
        caregiver_name: "",
        caregiver_password: "",
        caregiver_tel_no: "",
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => (
        <form
          className={clsx(classes.root, className)}
          onSubmit={(e) => handleSubmit(e, values)}
        >
          <Card>
            <CardHeader
              className={classes.card_header}
              title={formatMessage({id:'caregiver_add'})}
              titleTypographyProps={{align:"center",  color: 'inherit',  variant:'h4'}}
            />

            <CardContent>
              <Grid container spacing={2}>
                <Grid item lg={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiver_name && errors.caregiver_name)}
                    fullWidth
                    helperText={touched.caregiver_name && errors.caregiver_name}
                    label={formatMessage({id:'caregiver_name'})}
                    name="caregiver_name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    value={values.caregiver_name}
                    variant="outlined"
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiver_tel_no && errors.caregiver_tel_no)}
                    fullWidth
                    helperText={touched.caregiver_tel_no && errors.caregiver_tel_no}
                    label={formatMessage({id:'caregiver_tel'})}
                    name="caregiver_tel_no"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.caregiver_tel_no}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>
                <Grid item md={4} xs={12}></Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiver_password && errors.caregiver_password)}
                    fullWidth
                    helperText={touched.caregiver_password && errors.caregiver_password}
                    // label="패스워드"
                    label={formatMessage({id:'password'})}
                    name="caregiver_password"
                    type="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    required
                    value={values.caregiver_password}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>

                <Grid item md={4} xs={12}>
                  <TextField
                    error={Boolean(touched.caregiver_password_confirm && errors.caregiver_password_confirm)}
                    fullWidth
                    helperText={touched.caregiver_password_confirm && errors.caregiverPasswordConfirm}
                    // label="패스워드(확인)"
                    label={formatMessage({id:'password_confirm'})}
                    name="caregiver_password_confirm"
                    type="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    // onChange={handlePasswordChange2}
                    required
                    value={values.caregiver_password_confirm}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Grid>

                <Grid item md={4} xs={12}></Grid>


                <Grid item md={6} xs={12}>
                  <div className={classes.input_container}>
                    <MuiThemeProvider theme={theme}>

                      <Typography variant="body1" style={{ marginRight: '20px' }}>
                        <FormattedMessage id="caregiver_alarm_recv_time" />
                      </Typography>

                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={koLocale}>
                        <TimePicker
                          label={formatMessage({ id: 'caregiver_alarm_recv_start_time' })}
                          value={newStartTime}
                          onChange={(newValue) => setNewStartTime(newValue)}
                          ampm={false} // 24시간제
                          renderInput={(params) => <TextField {...params} />}
                        />
                        <Typography variant="body1" style={{ marginLeft: '20px', marginRight: '20px' }}>~</Typography>

                        <TimePicker
                          label={formatMessage({ id: 'caregiver_alarm_recv_end_time' })}
                          value={newEndTime}
                          onChange={(newValue) => setNewEndTime(newValue)}
                          ampm={false} // 24시간제
                          renderInput={(params) => <TextField {...params} />}
                        />

                      </LocalizationProvider>

                    </MuiThemeProvider>
                  </div>
                </Grid>

              </Grid>


              <Divider className={classes.divider}/>


              <Grid container spacing={2}>
                <Grid item md={12} xs={12} style={{marginLeft: theme.spacing(8), marginRight: theme.spacing(8)}} >

                <CardHeader
                className={classes.card_sub_header}
                title={formatMessage({id:'caregiver_charge_room_list'})}
                titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }} />

                  <FormControl sx={{ m: 3 }} style={{marginTop: theme.spacing(2) }} component="fieldset" variant="standard" >
                    {/* <FormLabel component="">담당 병실 리스트</FormLabel> */}
                    <FormGroup row={true}>

                      {roomList.map( (roomInfo, index) => (

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={ checkedState.length == 0 ? false : checkedState[index] }
                              // checked={ false }
                              onChange={ () => handleChange2(index) }
                              name={roomInfo.roomName}
                              sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                              />
                              // checked={state[roomInfo.roomName]} onChange={handleChange2} name={roomInfo.roomName}
                          }
                          label={<Typography variant="subtitle1" className={classes.checkbox_label}>{roomInfo.roomName}</Typography>}
                          style={{marginRight:'40px'}}
                        />
                      ))}

                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>


              <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                  <Typography align="center" color="error" variant="body1" noWrap={true}>
                    {errorText}
                  </Typography>
                </Grid>
              </Grid>

              <Divider className={classes.divider}/>

              <Grid item className={classes.action}>

                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  disabled={isSubmitting}
                  className={classes.action}
                >
                  <FormattedMessage id="caregiver_add" />
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  onClick={handleBack}
                  className={classes.action}
                >
                  <FormattedMessage id="cancel" />
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </form>
      )}
    </Formik>
  );
};

CaregiverAddForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default CaregiverAddForm;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  card_sub_header : {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.grey.main,
    marginTop: theme.spacing(4),
    borderRadius:6,
  },
  divider: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginLeft : theme.spacing(1),
    maringRight: theme.spacing(1),
    width:100,
  },
  input_container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent:'flex-start'
  },
}));

